"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SprinklerCoverage = exports.SprinklerType = exports.MVC_DURATION_LIMIT = exports.IRR_DURATION_LIMIT = exports.DEFAULT_SOLENOID_VOLTAGE = exports.enabledVibration = exports.hyperStatusTypes = exports.irrStatusTypes = exports.IrrStatusTypes = exports.VALVE_STATUS_COLORS = void 0;
const Helpers_1 = require("../../Helpers");
// export const VALVE_STATUS_COLORS: Record<ValveStatus, string> = {
//   [ValveStatus.ONLINE]: '#99FF99', // APP_GREEN
//   [ValveStatus.OFFLINE]: 'orange',
//   [ValveStatus.ERROR]: '',
//   [ValveStatus.IRRIGATING]: '',
//   [ValveStatus.UNSEEN]: '',
//   [ValveStatus.DISABLED]: '',
//   [ValveStatus.AREAPAUSED]: '',
//   [ValveStatus.AWAITINGPROGRAMME]: ''
// }
exports.VALVE_STATUS_COLORS = {
    online: '#99FF99', // APP_GREEN,
    irrigating: 'lightblue',
    'programme pending': 'royalblue',
    offline: 'orange',
    'never seen': 'yellow',
    disabled: 'purple',
    'paddock paused': 'pink',
    paused: 'pink',
    error: 'red',
    closed: 'red',
    'irrigated without vibration': 'cyan',
    open: '#99FF99', //APP_GREEN,
};
var IrrStatusTypes;
(function (IrrStatusTypes) {
    IrrStatusTypes["ONLINE"] = "Online - not irrigating";
    IrrStatusTypes["OFFLINE"] = "Offline";
    IrrStatusTypes["ERROR"] = "Error";
    IrrStatusTypes["IRRIGATING"] = "Irrigating";
    IrrStatusTypes["UNSEEN"] = "Never Seen";
    IrrStatusTypes["DISABLED"] = "Disabled";
    IrrStatusTypes["AREAPAUSED"] = "Paused";
    IrrStatusTypes["AWAITINGPROGRAMME"] = "Programme Pending";
    IrrStatusTypes["NO_VIBRATION"] = "Low Impact";
    IrrStatusTypes["LOWERBATTERY"] = "HYPER - Lower Battery";
})(IrrStatusTypes || (exports.IrrStatusTypes = IrrStatusTypes = {}));
exports.irrStatusTypes = [
    { name: 'Online - not irrigating', id: IrrStatusTypes.ONLINE, colour: exports.VALVE_STATUS_COLORS['online'] },
    { name: 'Offline', id: IrrStatusTypes.OFFLINE, colour: exports.VALVE_STATUS_COLORS['offline'] },
    { name: 'Disabled', id: IrrStatusTypes.DISABLED, colour: exports.VALVE_STATUS_COLORS['disabled'] },
    { name: 'Paused', id: IrrStatusTypes.AREAPAUSED, colour: exports.VALVE_STATUS_COLORS['paused'] },
    { name: 'Error', id: IrrStatusTypes.ERROR, colour: exports.VALVE_STATUS_COLORS['error'] },
    { name: 'Irrigating', id: IrrStatusTypes.IRRIGATING, colour: exports.VALVE_STATUS_COLORS['irrigating'] },
    { name: 'Never Seen', id: IrrStatusTypes.UNSEEN, colour: exports.VALVE_STATUS_COLORS['never seen'] },
    { name: 'Programme Pending', id: IrrStatusTypes.AWAITINGPROGRAMME, colour: exports.VALVE_STATUS_COLORS['programme pending'] },
];
exports.hyperStatusTypes = [{ name: 'HYPER - Lower Battery', id: IrrStatusTypes.LOWERBATTERY }];
exports.enabledVibration = [{ name: 'Low Impact', id: IrrStatusTypes.NO_VIBRATION, colour: 'white', glow: 'red' }];
exports.DEFAULT_SOLENOID_VOLTAGE = 12;
/** The max from UINT8  */
exports.IRR_DURATION_LIMIT = (0, Helpers_1.numberByteMax)(1); // 255
exports.MVC_DURATION_LIMIT = 1440;
/** Below is basically unused, and ready to be deleted */
var SprinklerType;
(function (SprinklerType) {
    SprinklerType["Senninger 8025"] = "Senninger 8025";
    SprinklerType["Senninger 8025-2ED"] = "Senninger 8025-2ED";
    SprinklerType["Senninger 8025-2RD"] = "Senninger 8025-2RD";
    SprinklerType["Senninger 8025-2SD"] = "Senninger 8025-2SD";
    SprinklerType["Komet K162 (FC)"] = "Komet K162 (FC)";
    SprinklerType["Komet K163 (PC)"] = "Komet K163 (PC)";
    SprinklerType["Sime Hidra (PC)"] = "Sime Hidra (PC)";
    SprinklerType["Senior (FC & PC)"] = "Senior (FC & PC)";
    SprinklerType["K1 (PC)"] = "K1 (PC)";
})(SprinklerType || (exports.SprinklerType = SprinklerType = {}));
var SprinklerCoverage;
(function (SprinklerCoverage) {
    SprinklerCoverage["90 degrees"] = "90";
    SprinklerCoverage["180 degrees"] = "180";
    SprinklerCoverage["270 degrees"] = "270";
    SprinklerCoverage["360 degrees"] = "360";
})(SprinklerCoverage || (exports.SprinklerCoverage = SprinklerCoverage = {}));
